import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import {
  createCollaborator,
  handleCollaboratorStatus,
  uploadCollaboratorPhoto,
} from 'app/service/collaborator/Collaborator';
import axios from 'axios';
import Direcciones from './sections/Direcciones';
import SelectComponent from '../../../components/FormComponents/SelectComponent';
import { KTSVG } from '_metronic/helpers';
import { Collapse } from 'react-bootstrap-v5';
import { JobsList } from './sections/JobsList';
import { DocumentsTemplate } from './sections/DocumentsTemplate';
import { DepositAccountsList } from './sections/DepositAccountsList';
import Deductions from './sections/Deductions';
import Perceptions from './sections/Perception';
import { Collaborator, CollaboratorResponse } from 'app/types/collaborator';
import { toaster } from 'app/utilities/commons';
import { PatternFormat } from 'react-number-format';
import { decodeToken } from 'app/utilities/decodeJWTToken';
import { useSelector } from 'react-redux';
import { RootState } from 'setup';
const API_URL = process.env.REACT_APP_API_NET;

// TODO agregar fecha planta en init values y al modelo que lo necesite

type Props = {
  id_row: number;
};

const INIT_VALUES = {
  name: "",
  paternalSurname: '',
  maternalSurname: '',
  photo: null,
  typeCollaborator: null,
  gender: null,
  curp: '',
  institutionalEmail: null,
  celullar: '',
  phone: '',
  email: '',
  birthDate: '',
  country: null,
  nationality: null,
  entity: null,
  birthCity: '',
  rfc: '',
  emergencyFullName: '',
  emergencyPhone: '',
  socialSecurity: '',
  numberEmployed: '',
  datePlant: '',
};

const ColaboradorSchema = Yup.object().shape({
  name: Yup.string().required('Este campo es requerido.'),
  // photo: Yup.string(), 
  paternalSurname: Yup.string().required('Este campo es requerido.'),
  maternalSurname: Yup.string().required('Este campo es requerido.'),
  typeCollaboratorId: Yup.string(),
  typeCollaborator: Yup.object({
    value: Yup.number(),
    label: Yup.string(),
  })
    .nullable()
    .required('Este campo es requerido'),
  // typeCollaborator: Yup.string().nullable().required("Este campo es requerido."),
  genderId: Yup.string(),
  // gender: Yup.string().nullable().required("Este campo es requerido."),
  gender: Yup.object({
    value: Yup.number(),
    label: Yup.string(),
  })
    .nullable()
    .required('Este campo es requerido'),
  curp: Yup.string().required('Este campo es requerido.').min(18, "CURP tiene que ser de 18 caracteres").max(18),
  institutionalEmail: Yup.string().nullable().notRequired().email('Deber ser válido. Ejemplo: juan@empresa.com'),
  celullar: Yup.string()
    .trim()
    .min(10, "Mínimo 10 dígitos")
    .max(12, "Máximo 10 dígitos")
    .required('Este campo es requerido.'),
  // .test(
  //   'min-length',
  //   'Ingresa un número de teléfono móvil válido.',
  //   (value: any) => {
  //     const v = value
  //       ? value.replace('(', '').replace(')', '').replace('+', '')
  //       : '';

  //     return v.trim().length >= 12;
  //   }
  // ),
  phone: Yup.string()
    .trim()
    .min(10, "Mínimo 10 números")
    .max(12, "Máximo 10 dígitos")
    .required('Este campo es requerido.'),
  birthDate: Yup.date().required('Este campo es requerido.'),
  countryId: Yup.string(),
  // country: Yup.string().nullable().required("Este campo es requerido."),
  country: Yup.object({
    value: Yup.number(),
    label: Yup.string(),
  })
    .nullable()
    .required('Este campo es requerido'),
  nationalityId: Yup.string(),
  // nationality: Yup.string().nullable().required("Este campo es requerido."),
  nationality: Yup.object({
    value: Yup.number(),
    label: Yup.string(),
  })
    .nullable()
    .required('Este campo es requerido'),
  entityId: Yup.string(),
  // entity: Yup.string().nullable().required("Este campo es requerido."),
  entity: Yup.object({
    value: Yup.number(),
    label: Yup.string(),
  })
    .nullable()
    .required('Este campo es requerido'),
  birthCity: Yup.string().required('Este campo es requerido.'),
  rfc: Yup.string().required('Este campo es requerido.').min(12, "El RFC tiene mínimo tiene 12 caracteres").max(13, "El RFC tiene máximo tiene 13 caracteres"),
  emergencyFullName: Yup.string().required('Este campo es requerido.'),
  emergencyPhone: Yup.string()
    .trim()
    .min(10, "Mínimo 10 números")
    .max(12, "Máximo 10 dígitos")
    .required('Este campo es requerido.'),
  email: Yup.string().required('Este campo es requerido.').email('Deber ser válido. Ejemplo: juan@gmail.com'),
  socialSecurity: Yup.string().nullable().notRequired().matches(/^[0-9]+$/, "Sólo se aceptan números").max(11, "Máximo 11 números"),
  numberEmployed: Yup.string().nullable().notRequired().max(10, "Máximo 10 caracteres"),
  datePlant: Yup.date().nullable()
    .min("2000-01-01", "Fecha no valida")
    .max("2030-01-01", "Fecha no valida").notRequired(),
});

const CollaboratorForm: React.FC<Props> = ({
  id_row,
}) => {
  const accessToken: any = useSelector<RootState>((state) => state.auth.accessToken);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledTypeCollaborator, setIsDisabledTypeCollaborator] = useState(false);
  const [openSection, setOpenSection] = useState<boolean>(false);
  const [openAddress, setOpenAddress] = useState<boolean>(false);
  const [openDocuments, setOpenDocuments] = useState<boolean>(false);
  const [openCuentas, setOpenCuentas] = useState<boolean>(false);
  const [openPerception, setOpenPerception] = useState<boolean>(false);
  const [openDeductions, setOpenDeductions] = useState<boolean>(false);
  const [collaborator, setCollaborator] = useState<Collaborator | undefined>();
  const [secondButton, setSecondButton] = useState('');
  const history = useHistory();
  const [typeCollaborator, setTypeCollaborator] = useState<[]>([]);
  const [previewImage, setPreviewImage] = useState<string>(
    `${process.env.PUBLIC_URL}/media/avatars/photo.png`
  );
  const [gender, setGender] = useState<[]>([]);
  const [country, setCountry] = useState<[]>([]);
  const [nationality, setNationality] = useState<[]>([]);
  const [entity, setEntity] = useState<[]>([]);

  const handleSecondButton = async () => {
    try {
      await handleCollaboratorStatus(collaborator?.id!, collaborator?.stateProcessId!);
      toaster.success('Se cambió el estatus con éxito');
      await fetchProfiles();
    } catch (error: any) {
      let message = 'Hubo un error al intentar actualizar el status del colaborador';
      if (error.response?.data?.errors?.length) {
        const filteredErrors = error.response.data.errors.filter((item: any) => !String(item.message ?? '').startsWith('Es requerido agregar un documento'));
        if (filteredErrors.length < error.response.data.errors.length) {
          filteredErrors.push({ message: 'Faltan uno o mas documentos' });
        }
        console.log(filteredErrors);
        message = filteredErrors.map((item: any) => item.message).join(', ');
      } else if (error.response?.data?.message) {
        message = error.response.data.message;
      }
      toaster.error(message);
    }
  };

  const fetchProfiles = async () => {
    try {
      if (typeCollaborator?.length && gender?.length && country?.length && nationality?.length && entity?.length && id_row) {
        const res = await axios.get<CollaboratorResponse>(`${API_URL}Collaborator/${id_row}`, { headers: { Authorization: `Bearer ${accessToken}` } });
        setCollaborator(res.data.data);
        formCollaborator.setValues({
          ...res.data.data,
          typeCollaborator: typeCollaborator.find((item: any) => item.value === res.data.data.typeCollaboratorId),
          gender: gender.find((item: any) => item.value === res.data.data.genderId),
          country: country.find((item: any) => item.value === res.data.data.countryId),
          nationality: nationality.find((item: any) => item.value === res.data.data.nationalityId),
          entity: entity.find((item: any) => item.value === res.data.data.entityId),
          celullar: res.data.data.cellular,
          datePlant: res.data.data.datePlant?.split("T")[0],
        });

        switch (res.data.data.stateProcessId) {
          case 3: //EN PROCESO
            setSecondButton('Solicitud de Alta');
            setIsDisabled(true);
            setIsDisabledTypeCollaborator(false);
            break;
          case 4: //GESTION DE ALTA
            setSecondButton('Alta');
            setIsDisabled(false);
            setIsDisabledTypeCollaborator(false);
            break;
          case 5: //TEMPORAL
            setSecondButton('Solicitar Planta');
            setIsDisabled(false);
            setIsDisabledTypeCollaborator(true);
            break;
          case 6: // PRACTICANTE
          case 7: // EXTERNO
            setIsDisabled(true);
            setIsDisabledTypeCollaborator(true);
            break;
          case 8: //GESTION DE PLANTA
            setSecondButton('Planta');
            setIsDisabled(false);
            setIsDisabledTypeCollaborator(true);
            break;
          case 9: // PLANTA
            setIsDisabled(false);
            setIsDisabledTypeCollaborator(true);
            break;
          default://1: NUEVO, 2:EN PROCESO, 3: EN TRAMITE
            setSecondButton('');
            setIsDisabled(true);
            setIsDisabledTypeCollaborator(true);
        }
      }
    } catch (error) {
      console.error('Error fetching positions:', error);
    }
  };

  const getImage = async (id: number) => {
    let res = { data: '', contentType: '' };
    let response = await axios.post(`${API_URL}Collaborator/${id}/image-profile-view`,
      {
        headers:
          { Authorization: `Bearer ${accessToken}` },
      }
    )

    setPreviewImage(response.data);
    return response.data;
  }

  useEffect(() => {
    fetchProfiles();
    getImage(id_row);
  }, [typeCollaborator, gender, country, nationality, entity, id_row]);

  useEffect(() => {
    const getCollaboratorData = async () => {
      const typeCollaboratorRes = await axios
        .get(`${API_URL}TypeCollaborator`)
        .catch(() => {
          console.error('Error en get TypeCollaborator');
        });
      const genderRes = await axios.get(`${API_URL}Genders`).catch(() => {
        console.error('Error en get Genders');
      });
      const countryRes = await axios.get(`${API_URL}Country`).catch(() => {
        console.error('Error en get COUNTRY');
      });
      const nationalityRes = await axios
        .get(`${API_URL}Nationality`)
        .catch(() => {
          console.error('Error en get NATIONALITY');
        });
      const entityRes = await axios.get(`${API_URL}Entity`).catch(() => {
        console.error('Error en get ENTITY');
      });
      if (
        typeCollaboratorRes &&
        genderRes &&
        countryRes &&
        nationalityRes &&
        entityRes
      ) {
        setTypeCollaborator(typeCollaboratorRes.data.data.records.map((item: any) => ({
          value: item.id,
          label: item.description,
        })));
        setGender(genderRes.data.data.records.map((item: any) => ({
          value: item.id,
          label: item.description,
        })));
        setCountry(countryRes.data.data.records.map((item: any) => ({
          value: item.id,
          label: item.description,
        })));
        setNationality(nationalityRes.data.data.records.map((item: any) => ({
          value: item.id,
          label: item.description,
        })));
        setEntity(entityRes.data.data.records.map((item: any) => ({
          value: item.id,
          label: item.description,
        })));
      }
    };
    getCollaboratorData();
  }, []);

  const formCollaborator = useFormik<any>({
    validationSchema: ColaboradorSchema,
    initialValues: INIT_VALUES,
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: false,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const collaborator = await createCollaborator({
          ...values,
          id: id_row,
          genderId: values?.gender?.value,
          typeCollaboratorId: values?.typeCollaborator?.value,
          countryId: values?.country?.value,
          nationalityId: values?.nationality?.value,
          entityId: values?.entity?.value,
          celullar: values?.celullar?.replaceAll(' ', ''),
          emergencyPhone: values?.emergencyPhone?.replaceAll(' ', ''),
          phone: values?.phone?.replaceAll(' ', ''),
        });

        const id = collaborator.data.id;
        if (values.photo === `${process.env.REACT_APP_API_NET}Collaborator/${id}/image-profile-view`) {
          await uploadCollaboratorPhoto(id ?? id_row, values.photo, accessToken)
            .catch((err) => {
              toaster.warning('El colaborador no tiene foto');
              console.error("Prueba", err);
            });
        } else {
          await uploadCollaboratorPhoto(id ?? id_row, values.photo, accessToken)
            .catch((err) => {
            });
          toaster.success("Se actualizó la información correctamente")
        }
        history.push('./');
        toaster.success(collaborator.data.message);
        formCollaborator.resetForm();
      } catch (err: any) {
        let message = 'Hubo un error al intentar crear/editar al colaborador';
        if (err.response?.data?.errors?.length) {
          message = err.response.data.errors.map((item: any) => item.message).join(', ');
        } else if (err.response?.data?.message) {
          message = err.response.data.message;
        }
        toaster.error(message);
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div>
        <form
          className="card mb-6"
          id="collaborator-main-form"
          onSubmit={formCollaborator.handleSubmit}
        >
          <div className="card-body d-flex flex-column flex-xl-row flex-row-fluid">
            <div
              className="image-input image-input-outline me-10"
              data-kt-image-input="true"
            >
              <label htmlFor="imageUpload">
                <div className='w-175px h-175px d-flex justify-content-center'>
                  <img
                    src={previewImage}
                    onError={() => setPreviewImage(`${process.env.PUBLIC_URL}/media/avatars/photo.png`)}
                    className='image-input-wrapper img-fluid w-175px cursor-pointer align-items-center'
                    crossOrigin="anonymous"
                    alt="Colaborador"
                    style={{
                      width: '175px',
                      height: '175px',
                      overflow: 'hidden',
                      objectFit: 'cover',
                      objectPosition: 'center',
                    }}
                  />
                </div>
              </label>
              <label
                className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                data-kt-image-input-action="change"
                data-bs-toggle="tooltip"
                title="Cambiar imagen"
              >
                <i className="bi bi-pencil-fill fs-7"></i>
                <input
                  type="file"
                  id="imageUpload"
                  accept=".png, .jpg, .jpeg"
                  {...formCollaborator.getFieldProps('photo')}
                  value={''}
                  onChange={(event) => {
                    if (event.currentTarget.files) {
                      const file = event.currentTarget.files[0];
                      const reader = new FileReader();
                      reader.onload = () => {
                        console.log('entro');
                        const preview: string = reader.result as string;
                        setPreviewImage(preview);
                      };
                      reader.readAsDataURL(file);
                      formCollaborator.setFieldValue('photo', file);
                    }
                  }}
                />
              </label>
            </div>
            <div className="w-100">
              <div className="w-100 pe-5">
                <input
                  className="form-control mb-2 w-100 border-0"
                  style={{
                    width: '100%',
                    padding: '15px',
                    fontSize: '24px',
                    boxSizing: 'border-box',
                    marginBottom: '20px',
                  }}
                  data-kt-element="input"
                  placeholder="Nombre*"
                  maxLength={25}
                  {...formCollaborator.getFieldProps('name')}
                ></input>
                {formCollaborator.touched.name && formCollaborator.errors.name && (
                  <div className="fv-plugins-message-container text-danger w-100">
                    <span role="alert">{formCollaborator.errors.name}</span>
                  </div>
                )}
              </div>
              <div className="d-flex">
                <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
                  <div className="mb-3 me-4">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Apellido Paterno
                      </label>
                    </div>
                    <input
                      className="form-control"
                      data-kt-element="input"
                      placeholder="Ramirez"
                      {...formCollaborator.getFieldProps('paternalSurname')}
                    ></input>
                    {formCollaborator.touched.paternalSurname &&
                      formCollaborator.errors.paternalSurname && (
                        <div className="fv-plugins-message-container text-danger w-100">
                          <span role="alert">
                            {formCollaborator.errors.paternalSurname}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
                  <div className="mb-3 me-4">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Apellido Materno
                      </label>
                    </div>
                    <input
                      className="form-control"
                      data-kt-element="input"
                      placeholder="Rodriguez"
                      {...formCollaborator.getFieldProps('maternalSurname')}
                    ></input>
                    {formCollaborator.touched.maternalSurname &&
                      formCollaborator.errors.maternalSurname && (
                        <div className="fv-plugins-message-container text-danger w-100">
                          <span role="alert">
                            {formCollaborator.errors.maternalSurname}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
                  <div className="mb-3 me-4">
                    <div className="w-100 d-flex">
                      <label className="fw-bold fs-6 mb-2 w-auto">
                        Número de Empleado
                      </label>
                    </div>
                    <input
                      className="form-control"
                      data-kt-element="input"
                      placeholder="xxxxxxxxxx"
                      disabled={isDisabled}
                      maxLength={10}
                      {...formCollaborator.getFieldProps('numberEmployed')}
                    ></input>
                    {formCollaborator.touched.numberEmployed &&
                      formCollaborator.errors.numberEmployed && (
                        <div className="fv-plugins-message-container text-danger w-100">
                          <span role="alert">
                            {formCollaborator.errors.numberEmployed}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* -------------------SEGUNDA SECCION------------------- */}
          <div className="card-body row">
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Tipo de Colaborador
                  </label>
                </div>
                <SelectComponent
                  disabled={isDisabledTypeCollaborator}
                  name="typeCollaborator"
                  formData={formCollaborator}
                  options={typeCollaborator}
                  display={'-1'}
                />
                {formCollaborator.touched.typeCollaborator &&
                  formCollaborator.errors.typeCollaborator && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.typeCollaborator}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Sexo
                  </label>
                </div>
                <SelectComponent
                  name="gender"
                  formData={formCollaborator}
                  options={gender}
                  display={'-1'}
                />
                {formCollaborator.touched.gender &&
                  formCollaborator.errors.gender && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.gender}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Curp
                  </label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  placeholder="GOCJ020927HQRMSSA6"
                  maxLength={18}
                  {...formCollaborator.getFieldProps('curp')}
                ></input>
                {formCollaborator.touched.curp && formCollaborator.errors.curp && (
                  <div className="fv-plugins-message-container text-danger w-100">
                    <span role="alert">{formCollaborator.errors.curp}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Celular
                  </label>
                </div>
                <PatternFormat
                  // data-kt-element="input"
                  {...formCollaborator.getFieldProps('celullar')}
                  className="form-control"
                  format="## #### #####"
                  onChange={(event) => {
                    formCollaborator.setFieldValue('celullar', event.target.value);
                  }}
                />
                {formCollaborator.touched.celullar &&
                  formCollaborator.errors.celullar && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.celullar}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Teléfono
                  </label>
                </div>
                <PatternFormat
                  // data-kt-element="input"
                  {...formCollaborator.getFieldProps('phone')}
                  className="form-control"
                  format="## #### #####"
                  onChange={(event) => {
                    formCollaborator.setFieldValue('phone', event.target.value);
                  }}
                />
                {formCollaborator.touched.phone &&
                  formCollaborator.errors.phone && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">{formCollaborator.errors.phone}</span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">Email</label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  {...formCollaborator.getFieldProps('email')}
                ></input>
                {formCollaborator.touched.email &&
                  formCollaborator.errors.email && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">{formCollaborator.errors.email}</span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Fecha de Nacimiento
                  </label>
                </div>
                <input
                  type="date"
                  className={`form-control`}
                  min={'1900-01-01'}
                  max={'2010-01-01'}
                  id="birthDate"
                  {...formCollaborator.getFieldProps('birthDate')}
                />
                {formCollaborator.touched.birthDate &&
                  formCollaborator.errors.birthDate && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.birthDate}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    País de Nacimiento
                  </label>
                </div>
                <SelectComponent
                  name="country"
                  formData={formCollaborator}
                  options={country}
                  display='-1'
                />
                {formCollaborator.touched.country &&
                  formCollaborator.errors.country && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.country}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Nacionalidad
                  </label>
                </div>
                <SelectComponent
                  name="nationality"
                  formData={formCollaborator}
                  options={nationality}
                  display='-1'
                />
                {formCollaborator.touched.nationality &&
                  formCollaborator.errors.nationality && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.nationality}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Estado de Nacimiento
                  </label>
                </div>
                <SelectComponent
                  name="entity"
                  formData={formCollaborator}
                  options={entity}
                  display='-1'
                />
                {formCollaborator.touched.entity &&
                  formCollaborator.errors.entity && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.entity}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Ciudad de Nacimiento
                  </label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  placeholder="Monterrey"
                  {...formCollaborator.getFieldProps('birthCity')}
                ></input>
                {formCollaborator.touched.birthCity &&
                  formCollaborator.errors.birthCity && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.birthCity}
                      </span>
                    </div>
                  )}
              </div>
            </div>

            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    RFC
                  </label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  placeholder=""
                  maxLength={14}
                  {...formCollaborator.getFieldProps('rfc')}
                ></input>
                {formCollaborator.touched.rfc && formCollaborator.errors.rfc && (
                  <div className="fv-plugins-message-container text-danger w-100">
                    <span role="alert">{formCollaborator.errors.rfc}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Contacto de Emergencia
                  </label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  placeholder="Maria Perez"
                  maxLength={15}
                  {...formCollaborator.getFieldProps('emergencyFullName')}
                ></input>
                {formCollaborator.touched.emergencyFullName &&
                  formCollaborator.errors.emergencyFullName && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.emergencyFullName}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Teléfono de Emergencia
                  </label>
                </div>
                <PatternFormat
                  // data-kt-element="input"
                  {...formCollaborator.getFieldProps('emergencyPhone')}
                  className="form-control"
                  format="## #### #####"
                  onChange={(event) => {
                    formCollaborator.setFieldValue('emergencyPhone', event.target.value);
                  }}
                />
                {formCollaborator.touched.emergencyPhone &&
                  formCollaborator.errors.emergencyPhone && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.emergencyPhone}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="fw-bold fs-6 mb-2 w-auto">
                    Correo Institucional
                  </label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  placeholder="juan@empresa.com"
                  {...formCollaborator.getFieldProps('institutionalEmail')}
                ></input>
                {formCollaborator.touched.institutionalEmail &&
                  formCollaborator.errors.institutionalEmail && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.institutionalEmail}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="fw-bold fs-6 mb-2 w-auto">
                    NSS
                  </label>
                </div>
                <input
                  className="form-control"
                  data-kt-element="input"
                  placeholder="71625309182"
                  type='text'
                  maxLength={11}
                  {...formCollaborator.getFieldProps('socialSecurity')}
                ></input>
                {formCollaborator.touched.socialSecurity &&
                  formCollaborator.errors.socialSecurity && (
                    <div className="fv-plugins-message-container text-danger w-100">
                      <span role="alert">
                        {formCollaborator.errors.socialSecurity}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            {(collaborator?.stateProcessId === 5 || collaborator?.stateProcessId === 8 || collaborator?.stateProcessId === 9) && (
              <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
                <div className="mb-3">
                  <div className="w-100 d-flex">
                    <label className="fw-bold fs-6 mb-2 w-auto">
                      Fecha de Planta
                    </label>
                  </div>
                  <input
                    type="date"
                    className={`form-control`}
                    id="datePlant"
                    {...formCollaborator.getFieldProps('datePlant')}
                  />
                  {formCollaborator.touched.datePlant &&
                    formCollaborator.errors.datePlant && (
                      <div className="fv-plugins-message-container text-danger w-100">
                        <span role="alert">
                          {formCollaborator.errors.datePlant}
                        </span>
                      </div>
                    )}
                </div>
              </div>
            )}
            <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4">
              <div className="mb-3">
                <div className="w-100 d-flex">
                  <label className="fw-bold fs-6 mb-2 w-auto">
                    Estatus
                  </label>
                </div>
                <h3 style={{ color: '#507fcd' }} className='badge badge-light-success fs-2'>
                  {collaborator?.stateProccess || "N/A"}
                </h3>
              </div>
            </div>
          </div>
        </form>

        <div className="card card-body p-0 mb-8">
          <div
            className="card-header cursor-pointer"
            style={{ backgroundColor: 'rgb(207,206,206,0.27)' }}
            onClick={() => {
              setOpenSection(!openSection);
            }}
            aria-controls="collapseProducts"
            aria-expanded={openSection}
          >
            <div className="card-title m-0" style={{ flex: 1 }}>
              <h3 className="fw-bolder m-0">Empleos</h3>
            </div>
            <div className="card-title m-0 p-4">
              <h3 className="m-0">{collaborator?.employe?.position ?? 'Puesto de empleo'}</h3>
            </div>
            <div className="d-flex align-items-center">
              <div
                className={`align-self-center`}
                style={{
                  transform: openSection
                    ? 'translateX(10%) rotate(-180deg)'
                    : '',
                  transition: 'transform 0.3s ease',
                }}
              >
                <KTSVG
                  path={'/media/icons/duotune/arrows/arr072.svg'}
                  className={`svg-icon-1`}
                />
              </div>
            </div>
          </div>

          <Collapse in={openSection}>
            <div id="collapseProducts">
              <div className="card-body border-top p-9">
                <JobsList
                  collaborator={collaborator}
                  refetch={() => {
                    fetchProfiles();
                  }}
                />
              </div>
            </div>
          </Collapse>
        </div>


        <div className="card card-body p-0 mb-8">
          <div
            className="card-header cursor-pointer"
            style={{ backgroundColor: "rgb(207,206,206,0.27)" }}
            onClick={() => setOpenCuentas(!openCuentas)}
            aria-controls="collapseDepositAccounts"
            aria-expanded={openSection}
          >
            <div className="card-title m-0" style={{ flex: 1 }}>
              <h3 className="fw-bolder m-0">Cuentas de Depósito</h3>
            </div>
            <div className="d-flex align-items-center">
              <div
                className="align-self-center"
                style={{
                  transform: openCuentas ? "translateX(10%) rotate(-180deg)" : "",
                  transition: "transform 0.3s ease",
                }}
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr072.svg"
                  className="svg-icon-1"
                />
              </div>
            </div>
          </div>

          <Collapse in={openCuentas}>
            <div id="collapseDepositAccounts">
              <div className="card-body border-top p-9">
                {/* Renderiza el componente DepositAccountsList con el `collabId` */}
                <DepositAccountsList collabId={collaborator?.id} />
              </div>
            </div>
          </Collapse>
        </div>

        <div className="card card-body p-0 mb-8">
          <div
            className="card-header cursor-pointer"
            style={{ backgroundColor: 'rgb(207,206,206,0.27)' }}
            onClick={() => {
              setOpenAddress(!openAddress);
            }}
            aria-controls="collapseProducts"
            aria-expanded={openAddress}
          >
            <div className="card-title m-0" style={{ flex: 1 }}>
              <h3 className="fw-bolder m-0">Direcciones</h3>
            </div>
            <div className="d-flex align-items-center">
              <div
                className={`align-self-center`}
                style={{
                  transform: openAddress
                    ? 'translateX(10%) rotate(-180deg)'
                    : '',
                  transition: 'transform 0.3s ease',
                }}
              >
                <KTSVG
                  path={'/media/icons/duotune/arrows/arr072.svg'}
                  className={`svg-icon-1`}
                />
              </div>
            </div>
          </div>

          <Collapse in={openAddress}>
            <div id="collapseProducts">
              <div className="card-body border-top p-9">
                <Direcciones collaborator={collaborator} />
              </div>
            </div>
          </Collapse>
        </div>

        <div className="card card-body p-0 mb-8">
          <div
            className="card-header cursor-pointer"
            style={{ backgroundColor: "rgb(207,206,206,0.27)" }}
            onClick={() => {
              setOpenPerception(!openPerception);
            }}
            aria-controls="collapseProducts"
            aria-expanded={openPerception}
          >
            <div className="card-title m-0" style={{ flex: 1 }}>
              <h3 className="fw-bolder m-0">Percepciones</h3>
            </div>
            <div className="d-flex align-items-center">
              <div
                className={`align-self-center`}
                style={{
                  transform: openPerception
                    ? 'translateX(10%) rotate(-180deg)'
                    : '',
                  transition: 'transform 0.3s ease',
                }}
              >
                <KTSVG
                  path={'/media/icons/duotune/arrows/arr072.svg'}
                  className={`svg-icon-1`}
                />
              </div>

            </div>
          </div>

          <Collapse in={openPerception}>
            <div id="collapseProducts">
              <div className="card-body border-top p-9">
                <Perceptions
                  collaborator={collaborator}
                />
              </div>
            </div>
          </Collapse>
        </div>

        <div className="card card-body p-0 mb-8">
          <div
            className="card-header cursor-pointer"
            style={{ backgroundColor: "rgb(207,206,206,0.27)" }}
            onClick={() => {
              setOpenDeductions(!openDeductions);
            }}
            aria-controls="collapseProducts"
            aria-expanded={openDeductions}
          >
            <div className="card-title m-0" style={{ flex: 1 }}>
              <h3 className="fw-bolder m-0">Deducciones</h3>
            </div>
            <div className="d-flex align-items-center">
              <div
                className={`align-self-center`}
                style={{
                  transform: openDeductions
                    ? 'translateX(10%) rotate(-180deg)'
                    : '',
                  transition: 'transform 0.3s ease',
                }}
              >
                <KTSVG
                  path={'/media/icons/duotune/arrows/arr072.svg'}
                  className={`svg-icon-1`}
                />
              </div>

            </div>
          </div>

          <Collapse in={openDeductions}>
            <div id="collapseProducts">
              <div className="card-body border-top p-9">
                <Deductions
                  collaborator={collaborator!}
                />
              </div>
            </div>
          </Collapse>
        </div>

        <div className="card card-body p-0 mb-8">
          <div
            className="card-header cursor-pointer"
            style={{ backgroundColor: 'rgb(207,206,206,0.27)' }}
            onClick={() => {
              setOpenDocuments(!openDocuments);
            }}
            aria-controls="collapseProducts"
            aria-expanded={openDocuments}
          >
            <div className="card-title m-0" style={{ flex: 1 }}>
              <h3 className="fw-bolder m-0">Documentos</h3>
            </div>
            <div className="d-flex align-items-center">
              <div
                className={`align-self-center`}
                style={{
                  transform: openAddress
                    ? 'translateX(10%) rotate(-180deg)'
                    : '',
                  transition: 'transform 0.3s ease',
                }}
              >
                <KTSVG
                  path={'/media/icons/duotune/arrows/arr072.svg'}
                  className={`svg-icon-1`}
                />
              </div>
            </div>
          </div>

          <Collapse in={openDocuments}>
            <div id="collapseProducts">
              <div className="card-body border-top p-9 d-flex">
                <div style={{ width: '40%' }}>
                  <h3>Tipo de Documento</h3>
                </div>
                <div style={{ width: '60%' }}>
                  <h3>Documento</h3>
                </div>
              </div>
              <DocumentsTemplate
                account={id_row}
                collaborator={collaborator}
                refetch={() => {
                  fetchProfiles();
                }}
              />
            </div>
          </Collapse>
        </div>

        <div className="d-flex justify-content-end mt-10">
          <button
            type="reset"
            className="btn btn-light me-3"
            data-kt-users-modal-action="cancel"
            onClick={() => {
              history.goBack();
            }}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            form="collaborator-main-form"
            disabled={loading}
          >
            Guardar
            {loading && (
              <span className="indicator-progress" style={{ display: 'block' }}>
                Espere por favor...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>
          {!!collaborator && [3, 4, 5, 8].includes(collaborator.stateProcessId) && (
            <button
              className="btn btn-primary ms-3"
              disabled={loading}
              onClick={handleSecondButton}
            >
              {secondButton}
              {loading && (
                <span className="indicator-progress" style={{ display: 'block' }}>
                  Espere por favor...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </>
  );
};
export { CollaboratorForm };
